import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFlowRateUnitList as getFlowRateUnitListApi,
	getFlowRateUnitListQuery as getFlowRateUnitListQueryApi,
	getFlowRateUnit as getFlowRateUnitApi,
	addNewFlowRateUnitApi,
	updateFlowRateUnitApi,
	deleteFlowRateUnitApi,
	checkFlowRateUnitExistsApi,
} from '../../helpers/flow_rate_unit/api_helper';

export const getFlowRateUnitList = createAsyncThunk(
	'flowRateUnit/getFlowRateUnitList',
	async () => {
		try {
			const response = await getFlowRateUnitListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las unidades de medida.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getFlowRateUnitListQuery = createAsyncThunk(
	'flowRateUnit/getFlowRateUnitListQuery',
	async params => {
		try {
			const response = getFlowRateUnitListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFlowRateUnit = createAsyncThunk(
	'flowRateUnit/getFlowRateUnit',
	async flow_rate_unit_id => {
		try {
			const response = await getFlowRateUnitApi(flow_rate_unit_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la unidad de medida.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewFlowRateUnit = createAsyncThunk(
	'flowRateUnit/addNewFlowRateUnit',
	async flow_rate_unit => {
		try {
			const response = await addNewFlowRateUnitApi(flow_rate_unit);
			toast.success('Unidad de Medida agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la unidad de medida.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateFlowRateUnit = createAsyncThunk(
	'flowRateUnit/updateFlowRateUnit',
	async flow_rate_unit => {
		try {
			const response = await updateFlowRateUnitApi(flow_rate_unit);
			toast.success('Unidad de Medida actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la unidad de medida.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteFlowRateUnit = createAsyncThunk(
	'flowRateUnit/deleteFlowRateUnit',
	async flow_rate_unit => {
		try {
			const response = await deleteFlowRateUnitApi(flow_rate_unit._id);
			toast.success('Unidad de Medida eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return flow_rate_unit;
		} catch (error) {
			toast.error('Error al eliminar la unidad de medida.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkFlowRateUnitExists = createAsyncThunk(
	'flowRateUnit/checkFlowRateUnitExists',
	async name => {
		try {
			const response = await checkFlowRateUnitExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
